import Modal from '../..';
import Form from '../../../Form';
import useStore from '../../../Hooks/useStore';

const ModalValidityDelete = () => {
  const [getters, setters] = useStore();
  const {
    modal: { getModal },
  } = getters;
  const {
    validity: { setValidity },
    modal: { closeSingleModal },
  } = setters;
  const isOpen = getModal('single.deleteValidity');
  const onClose = () => {
    closeSingleModal('deleteValidity');
    setValidity('selected.validity', null);
  };
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      headerTitle="Excluir validade"
      height={'auto'}
      width={'30vw'}
    >
      <Form.Validity.Validity.Delete />
    </Modal>
  );
};

export default ModalValidityDelete;
